import { QueryResource } from '@/lib/datx-jsonapi-react';
import { NewsArticle } from '@/resources/NewsArticle';

export const getNewsArticleById = (id: string): QueryResource<NewsArticle> => {
  return id ? [NewsArticle, id, { include: 'news_article_topics' }] : null;
};
